package uz.mint.frontend.pages

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.add
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobweb.core.layout.Layout
import uz.mint.frontend.components.layouts.PageLayoutData
import uz.mint.frontend.components.sections.LoginPage
import uz.mint.frontend.i18n.Locale
import uz.mint.frontend.i18n.accountStringsFor

/** Sign-in in Russian, the default locale, at /login. */
private val LOCALE = Locale.RU

@InitRoute
fun initLoginRoutePage(ctx: InitRouteContext) {
    val account = accountStringsFor(LOCALE)
    ctx.data.add(PageLayoutData(account.loginMetaTitle, LOCALE, account.loginMetaDescription))
}

@Page
@Layout(".components.layouts.PageLayout")
@Composable
fun LoginRoutePage() {
    LoginPage(LOCALE)
}
